export default "__VITE_ASSET__BOMHRX8E__"